function jobSearchText(job) {
  return `${job?.step_desc || ""} ${job?.url || ""}`.toLowerCase();
}

export function isLoginJob(job) {
  const text = jobSearchText(job);
  return text.includes("login") || text.includes("登录");
}

export function isVerifyCodeJob(job) {
  const text = jobSearchText(job);
  return text.includes("verifycode") || text.includes("验证码");
}

export function isAuthJob(job) {
  return isLoginJob(job) || isVerifyCodeJob(job);
}

function parseJsonValue(value) {
  if (!value) {
    return null;
  }
  if (typeof value === "object") {
    return value;
  }
  if (typeof value !== "string") {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}

function firstPresent(values) {
  return values.find((value) => value !== undefined && value !== null && value !== "");
}

export function extractLoginCredentials(job) {
  const result = parseJsonValue(job?.last_response);
  if (!result) {
    return null;
  }

  const body =
    parseJsonValue(result.response) ||
    parseJsonValue(result.http_response && result.http_response.body) ||
    result;
  const data = body && typeof body === "object" ? body.data || body : {};
  const userVo = data && typeof data === "object" ? data.userVo || {} : {};

  const sessionKey = firstPresent([
    data.sessionKey,
    data.session_key,
    data.token,
    data.accessToken,
    body.sessionKey,
    body.session_key,
  ]);
  const userId = firstPresent([
    userVo.userId,
    userVo.id,
    data.userId,
    data.uid,
    body.userId,
  ]);

  if (!sessionKey || userId === undefined || userId === null || userId === "") {
    return null;
  }

  return {
    sessionKey: String(sessionKey),
    userId: String(userId),
  };
}
